import React, { useEffect, useState } from 'react'
import { ContainerCatalogo } from './styles'
import ViewPage from '../../../../Components/ViewPage'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import { TabelaCatalogoPragas } from './components/tabela'
import {
  delMoniEspecie,
  getMoniEspecie,
  MoniEspecieItens,
  postMoniEspecie,
  putMoniEspecie,
  TypeMoniEspecie,
} from '../../../../services/monitoramento/especie'
import { AxiosResponse } from 'axios'
import { Drawer } from 'antd'
import { NavegacaoDrawer } from '../../recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import ButtonCustom from '../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FormCatalogoForm } from '../../../../Components/monitoramento/catalogoPragasFormNovo'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'

const CatalogoDePragas: React.FC = () => {
  const [loadingTable, setLoadingTable] = useState(false)
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [update, setUpdate] = useState(null)
  const [open, setOpen] = useState(false)
  const [dataListEstadio, setDataListEstadio] = useState<MoniEspecieItens[]>([])
  const [variacao_remover, setVariacao_remover] = useState([])

  //TABELA
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState(null)
  const [buscarTabela, setBuscarTabela] = useState('')
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)

  //FORMULARIO
  const [loadingForm, setLoadingForm] = useState(false)
  const [loadingSalvar, setLoadingSalvar] = useState(false)
  const [nome, setNome] = useState<string>('')
  const [nomeCientifico, setNomeCientifico] = useState<string>('')
  const [categoria, setCategoria] = useState<string>('')
  const [categoriaId, setCategoriaId] = useState<number>(null)
  const [variacao, setVariacao] = useState<string>('')
  const [dataVariacoes, setDataVariacoes] = useState([])

  const listEstadio = async () => {
    setLoadingTable(true)
    const response: AxiosResponse<TypeMoniEspecie> = await getMoniEspecie({
      page: page,
      pagination: pagination,
      nome: buscarTabela,
    })

    setDataListEstadio(response.data.itens)
    setTotal(response.data.total)
    setLoadingTable(false)
  }

  function abrirGaveta() {
    setOpen(true)
  }

  function editarCadastro(cod) {
    setOpen(true)
    setUpdate(cod)
  }

  function fecharGaveta() {
    setOpen(false)
    setUpdate(null)
    setNome('')
    setNomeCientifico('')
    setCategoria('')
    setCategoriaId(null)
    setVariacao('')
    setDataVariacoes([])
    setVariacao_remover([])
  }

  const editEstadio = async (data) => {
    loadingAlert({ msg: 'Carregando...', id: 'get_moni_especi' })
    setLoadingForm(true)
    const response: AxiosResponse<TypeMoniEspecie> = await getMoniEspecie({
      cod: data,
      embed: 'variacao',
    })

    const dados = response.data.itens[0]
    setNome(response.data.itens[0].nome)
    setNomeCientifico(response.data.itens[0].nome_cientifico)
    setCategoria(response.data.itens[0].categoria_nome)
    setCategoriaId(response.data.itens[0].cod_categoria)
    setDataVariacoes(dados?.variacao)
    setLoadingForm(false)
    destroyAlert('get_moni_especi')
  }

  function inserirVariacao() {
    setDataVariacoes((dataVariacao) => [
      ...dataVariacao,
      {
        cod_temp: Date.now().toString(),
        nome: variacao,
      },
    ])
    setVariacao('')
  }

  async function deletarVariacao(cod) {
    if (typeof cod === 'string') {
      let remover = dataVariacoes.filter((item) => item.cod_temp !== cod)
      setDataVariacoes(remover)
    }

    if (typeof cod === 'number') {
      let remover = dataVariacoes.filter((item) => item.cod !== cod)
      setVariacao_remover((prev) => {
        const updatedIds = [...prev, cod]

        return updatedIds
      })
      setDataVariacoes(remover)
    }
  }

  async function deletarCatalogo(cod) {
    setFake_loading(true)
    const response = await delMoniEspecie(cod)

    if (response.status === 200) {
      successAlert('Espécie excluida com sucesso!')
      listEstadio()
      setTimeout(() => {
        setFake_loading(false)
      }, 3600)
    }
  }

  async function salvarCatalogoPraga() {
    setLoadingSalvar(true)
    const data = {
      nome: nome,
      nome_cientifico: nomeCientifico,
      cod_categoria: categoriaId,
      variacao: dataVariacoes,
      variacao_remover: [],
      status: 1,
    }
    loadingAlert({ msg: 'Salvando...', id: 'salvando_especie' })

    try {
      if (update <= 0) {
        const response: AxiosResponse<TypeMoniEspecie> = await postMoniEspecie(data)
        if (response.status === 201) {
          successAlert('Espécie cadastrada com sucesso', 5000, 'salvando_especie')
          listEstadio()
          fecharGaveta()
          setLoadingSalvar(false)
        }
      } else {
        data.variacao_remover = variacao_remover
        const response: AxiosResponse<TypeMoniEspecie> = await putMoniEspecie(update, data)
        if (response.status === 200) {
          successAlert('Espécie atualizada com sucesso!', 5000, 'salvando_especie')
          editEstadio(update)
          setLoadingSalvar(false)
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data.error ?? 'Falha ao registrar espécie!', 5000, 'salvando_especie')
          setLoadingSalvar(false)
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha ao registrar espécie!', 5000, 'salvando_especie')
            setLoadingSalvar(false)
          })
        }
      } else {
        destroyAlert()
        setLoadingSalvar(false)
      }
    }
  }

  useEffect(() => {
    if (update > 0) {
      editEstadio(update)
    }
  }, [update])

  useEffect(() => {
    listEstadio()
  }, [])

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        listEstadio()
      }, 700)
    }
    if (buscarTabela === '') {
      listEstadio()
    }
  }, [buscarTabela])

  useEffect(() => {
    listEstadio()
  }, [pagination])

  useEffect(() => {
    listEstadio()
  }, [page])

  return (
    <ContainerCatalogo>
      <ViewPage
        title='Catálogo de pragas, doenças e plantas daninhas'
        btnClick={null}
        newHide
        rotina={35}
        onPermission={setPermissions}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Catálogo de pragas, doenças e plantas daninhas</TitleH1>
        </div>

        <TabelaCatalogoPragas
          loading={loadingTable}
          listar_catalogo={dataListEstadio}
          abrir={abrirGaveta}
          editarCadastro={editarCadastro}
          deletar={deletarCatalogo}
          setPagination={setPagination}
          page={page}
          setPage={setPage}
          total={total}
          permissao={permissions}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          setFake_loading={setFake_loading}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
        />

        <Drawer
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={fecharGaveta}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
          open={open}
          width={500}
          onClose={fecharGaveta}
          closable={false}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: '10px 10px' }}
          footer={
            <div className='footer'>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                type='primary'
                onClick={salvarCatalogoPraga}
              >
                Salvar
              </ButtonCustom>
            </div>
          }
          destroyOnClose
        >
          <FormCatalogoForm
            loadingForm={loadingForm}
            update={update}
            nome={nome}
            setNome={setNome}
            nomeCientifico={nomeCientifico}
            setNomeCientifico={setNomeCientifico}
            categoria={categoria}
            setCategoria={setCategoria}
            categoriaId={categoriaId}
            setCategoriaId={setCategoriaId}
            variacao={variacao}
            setVariacao={setVariacao}
            dataVariacao={dataVariacoes}
            inserirVariacao={inserirVariacao}
            deletarVariacao={deletarVariacao}
          />
        </Drawer>
      </ViewPage>
    </ContainerCatalogo>
  )
}

export default CatalogoDePragas
